


























import type { PropType } from '@nuxtjs/composition-api';
import { computed, defineComponent } from '@nuxtjs/composition-api';
import { storeToRefs } from 'pinia';
import SfAddressPicker from '~/components/JetUi/molecules/SfAddressPicker/SfAddressPicker.vue';
import { Countries } from '~/composables';
import userCheckoutAddressesGetters from '~/modules/customer/getters/userCheckoutAddressesGetter';
import { useCheckoutStore } from '~/stores/checkout';
import BillingAddressDetails from './BillingAddressDetails.vue';

export default defineComponent({
  name: 'BillingAddress',
  components: {
    SfAddressPicker,
    BillingAddressDetails,
  },
  props: {
    currentAddressId: {
      type: Number,
      default: null,
    },
    value: {
      type: Boolean,
      required: true,
    },
    countries: {
      type: Array as PropType<Countries[]>,
      default: () => [],
    },
    originMethods: {
      type: String,
      default: '',
    },
  },
  emits: ['setCurrentAddress'],
  setup(props, { emit }) {
    const { addresses } = storeToRefs(useCheckoutStore());
    const updatedAddresses = computed(() => addresses.value.map((address) => ({
      ...address,
      countryName:
                    props.countries.find(({ id }) => id === address.country_code)?.full_name_locale
                    ?? address.country_code,
    })));
    const emitSetCurrentAddress = (addressId: number) => {
      const address = addresses.value.find(({ id }) => id === Number(addressId));
      if (address) {
        emit('setCurrentAddress', address);
      }
    };

    return {
      emitSetCurrentAddress,
      updatedAddresses,
      userCheckoutAddressesGetters,
    };
  },
});
